"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This is run first to identify the session with user data
 * @param {string} [userId] - The id of the user we are saying is the user for this session
 */
var appcuesIdentify = exports.appcuesIdentify = function appcuesIdentify() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.Appcues.anonymous();

  if (window.Appcues) {
    window.Appcues.identify(userId, {});
  }
};

/**
 * This is run on page load to query the Appcues server to ask if there are any workflows that need to be run
 */
var appcuesPage = exports.appcuesPage = function appcuesPage() {
  if (window.Appcues) {
    window.Appcues.page();
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/AppcuesService.js
// module id = 808
// module chunks = 10